'use strict';
var activeClass, flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

activeClass = 'flyActive';

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts, nestedMenulinks;
    $goodsTab = $('#subnav-goods-tab,#subnav-shop-tab');
    if (!($menuElem = $goodsTab.find('.flyMenu')).length) {
      return;
    }
    nestedMenulinks = '> li:not(.flyFlatLink)';
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: nestedMenulinks,
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass(activeClass);
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass(activeClass);
      }
    };
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find(nestedMenulinks);
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};

